<script>
import * as icons from 'vue-feather-icons'

export default {
  name: 'FeatherIcon',
  functional: true,
  props: {
    icon: {
      required: true,
      type: [String, Object]
    },
    size: {
      type: String,
      default: '11.2'
    },
    badge: {
      type: [String, Object, Number],
      default: null
    },
    badgeClasses: {
      type: [String, Object, Array],
      default: 'badge-primary'
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  render (h, { props, data }) {
    // Create Feather Icon
    const svg = h(icons[props.icon], { props: { size: props.size }, ...data })

    // If no badge is provided => Render just SVG
    if (!props.badge) return h('div', { staticClass: `feather-icon position-relative ${props.customClass}` }, [svg])

    // Badge
    const badgeEl = h('span', { staticClass: 'badge badge-up badge-pill', class: props.badgeClasses }, [props.badge])

    // Return span with children
    return h('span', { staticClass: `feather-icon position-relative ${props.customClass}` }, [svg, badgeEl])
  }
}
</script>

<style lang="scss">
svg.feather {
  outline: none
}

.filled-star svg {
  fill: #ea5455;
  stroke: #ea5455;
  color: #ea5455;
}
.unfilled-star svg {
  stroke: #ea5455;
  color: #ea5455;
}
</style>
